(function () {
  const root = document.querySelector("[data-console-lock]");
  if (!root) return;

  const stream = root.querySelector("[data-stream]");
  const rain = root.querySelector("[data-rain]");
  if (!stream) return;

  // ---- Terminal Messages ----
  const LINES = [
    "SITE LOCKED",
    "WE WILL BE BACK SOON",
    "SITE RESTRICTED",
    "UNDER CONSTRUCTION",
    "ACCESS DENIED",
    "DEPLOY IN PROGRESS",
    "SECURITY MODE: ENABLED",
    "CHECK BACK LATER",

    // Merch / promo
    "NEW IDLEGLANCE MERCH RELEASED",
    "NEW MERCH IS OUT IDLEGLANCE.SHOP",
    "IDLEGLANCE.SHOP",
    "MERCH RELEASE",
    "DROP LIVE",
    "STORE STATUS: ONLINE (EXTERNAL)",
    "OPEN: IDLEGLANCE.SHOP"
  ];

  const GLITCHES = [
    "ERR::SYNC_DESYNC",
    "WARN::PACKET_LOSS",
    "TRACE::REWRITE_BUFFER",
    "SIG::INTERRUPT",
    "MEM::SCRUB_ACTIVE",
    "IO::STREAM_CORRUPT",
    "KERN::REMAP_STATE"
  ];

  const maxLines = 10;

  function rand(arr){ return arr[Math.floor(Math.random() * arr.length)]; }
  function nowStamp(){
    const d = new Date();
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    const ss = String(d.getSeconds()).padStart(2, "0");
    return `${hh}:${mm}:${ss}`;
  }

  function pushLine(text, strong = false) {
    const el = document.createElement("div");
    el.className = "consoleLock__line";
    el.innerHTML = strong ? `<strong>[${nowStamp()}]</strong> ${text}` : `[${nowStamp()}] ${text}`;
    stream.appendChild(el);

    while (stream.children.length > maxLines) {
      stream.removeChild(stream.firstChild);
    }
  }

  // Seed
  pushLine("BOOT::CONSOLE_READY", true);
  pushLine("STATUS::LOCK_ACTIVE", true);
  pushLine(rand(LINES));

  // Steady updates
  setInterval(() => {
    const pick = Math.random() < 0.18 ? rand(GLITCHES) : rand(LINES);
    pushLine(pick, pick.includes("::"));
  }, 900);

  // Glitch burst
  setInterval(() => {
    if (Math.random() > 0.55) return;
    let n = 0;
    const burst = setInterval(() => {
      n++;
      pushLine(rand(GLITCHES), true);
      pushLine(rand(LINES));
      if (n >= 3) clearInterval(burst);
    }, 120);
  }, 2600);

  // ---- Falling Clickable NEW MERCH Rain ----
  if (!rain) return;

  const MERCH_URL = "https://idleglance.shop";
  const DROP_TEXTS = [
    "NEW MERCH",
    "IDLEGLANCE.SHOP",
    "MERCH DROP",
    "10 YEAR ANNIVERSARY"
  ];

  function spawnDrop() {
    const a = document.createElement("a");
    a.className = "consoleLock__drop";
    a.href = MERCH_URL;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.textContent = rand(DROP_TEXTS);

    // Position + speed
    const x = Math.random() * 100;     // vw
    const dur = 5.2 + Math.random() * 4.2; // seconds
    const size = 10 + Math.random() * 4;   // px-ish via font-size
    const alpha = 0.45 + Math.random() * 0.45;

    a.style.left = `${x}vw`;
    a.style.setProperty("--fall", `${dur}s`);
    a.style.fontSize = `${size}px`;
    a.style.opacity = `${alpha}`;

    // Random glitch mode
    if (Math.random() < 0.45) a.classList.add("is-glitch");

    // Slight random horizontal drift for feel
    const drift = (Math.random() * 14 - 7).toFixed(2);
    a.style.transform = `translate3d(${drift}px, -12vh, 0)`;

    // Remove when done
    const removeAfter = (dur * 1000) + 200;
    setTimeout(() => a.remove(), removeAfter);

    rain.appendChild(a);
  }

  // Spawn loop
  const rainInterval = setInterval(() => {
    // keep it light so it doesn't spam
    spawnDrop();
    if (Math.random() < 0.35) spawnDrop();
  }, 650);

  // Safety: stop if page hidden
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      clearInterval(rainInterval);
    }
  }, { passive: true });
})();
